import * as React from 'react'

/**
 * The View menu icon for the time-based variation: the axis, with a scan taken and one missed.
 */
export default () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 0V14" stroke="#CED9E7" />
    <circle cx="7" cy="3.5" r="3" fill="#001335" />
    <circle cx="7" cy="10.5" r="2.5" fill="none" stroke="#727B8C" />
  </svg>
)
